import { MENU_FIELD_COPY } from '../constants';

// Owner, 2026-10-07: a public coupon may name the menus it applies to. The
// API stores them like `platforms`, a comma-separated string; the form
// works with an array.
export const menuIdsToArray = (menuids) =>
  String(menuids || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

export const arrayToMenuIds = (ids) =>
  ids && ids.length ? ids.join(',') : null;

export const menuNamesLabel = (menunames, empty = MENU_FIELD_COPY.any) =>
  menunames && menunames.length ? menunames.join(', ') : empty;

// Menu/List answers every company menu whatever storeid it is given
// (MenuController.cs:88 ORs them back in); a coupon on one store may only
// name the menus that store carries.
export const menusForStore = (menus, storeid) =>
  storeid
    ? menus.filter((m) =>
        (m.menustores || []).some((ms) => ms.storeid === storeid),
      )
    : menus;

// An older API ignores `menuids` on Upsert and answers without them: the
// coupon would be saved unrestricted while the form said otherwise. The
// read-back is PublicCoupon/Get (the entity: `menuids`, no `menunames`);
// List/GetAvailable carry `menunames`. Either proves the server knows the
// field.
export const menusWereSaved = (sentMenuids, savedCoupon) =>
  !sentMenuids ||
  Array.isArray(savedCoupon?.menunames) ||
  Boolean(savedCoupon?.menuids);
